<!--线索档案详情-->
<template>
  <article>
    <group gutter="0px" class="status">
      <x-input title="客户姓名" placeholder="请输姓名" v-model="clue.customer_name"></x-input>
      <cell v-if="id" title="联系电话">{{clue.mobile}}</cell>
      <x-input v-else title="联系电话" placeholder="请输电话" v-model="clue.mobile"></x-input>
    </group>
    <group title="到店信息" class="status">
      <cell title="购车意向" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group">
          <cell @click.native="selModels(true,index,item.car_model_id)"
                v-for="(item,index) in clue.intention_cars" :key="index"
                :title="item.car_model_name+'-'+item.inner_color_ch+'-'+item.outer_color_ch" class="car-intention"
                is-link>
          </cell>
          <cell v-if="clue.intention_cars.length < 3" @click.native="selModels(true)" title="请选择+"
                class="car-intention f-color"
                is-link>
          </cell>
        </div>
      </cell>
      <cell title="竞品车型" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group"><!--最多三个-->
          <cell @click.native="selModels(false,index,item.model_id)"
                v-for="(item,index) in clue.contrast_cars" :key="index"
                :title="item.model_name" class="car-intention"
                is-link>
          </cell>
          <cell v-if="clue.contrast_cars.length < 3" @click.native="selModels(false)" title="请选择+"
                class="car-intention f-color"
                is-link>
          </cell>
        </div>
      </cell>
      <cell v-if="id" title="线索来源" :value="getValues(clue.from_type)"></cell>
      <selector v-else title="线索来源" v-model="clue.from_type" :options="fromType"></selector>
      <x-address
        v-model="chanelList"
        title="客户渠道"
        show-name
        class="address-before"
        :list="channelData"
        placeholder="请选择"
        hideDistrict>
      </x-address>
      <x-address
        v-model="addressList"
        title="地区来源"
        @on-change="handleAddress"
        show-name
        class="address-before"
        placeholder="请选择">
      </x-address>
      <x-input title="详细地址" placeholder="街道门牌信息" v-model="clue.address"></x-input>
    </group>
    <group title="提醒设置" v-if="this.id">
      <datetime title="预约到店" class="datetime" placeholder="请选择预约到店时间" v-model="clue.next_arrive_at"
                format="YYYY-MM-DD HH:mm" year-row="{value}年" month-row="{value}月" day-row="{value}日"
                hour-row="{value}时" minute-row="{value}分" confirm-text="完成" cancel-text="取消" :min-hour="8"
                :max-hour="19" :start-date="start_date" :end-date="end_date"></datetime>
      <datetime title="下次致电" class="datetime" placeholder="请选择下次致电时间" :start-date="start_date" :end-date="end_date"
                format="YYYY-MM-DD" year-row="{value}年" month-row="{value}月" day-row="{value}日" confirm-text="完成"
                cancel-text="取消" v-model="clue.next_contact_at"></datetime>
    </group>
    <group title="跟进记录" v-if="clue.notes.length">
      <cell class="sale-record" v-for="(item, index) in  clue.notes" :key="index">
        <p slot="after-title" class="content">{{item.remark}}</p>
        <p slot="after-title" class="time">{{item.created_at}}</p>
      </cell>
    </group>
    <group class="status">
      <cell title="建档人员" :value="clue.creator"></cell>
    </group>
    <x-dialog v-model="isShow" :hideOnBlur="true">
      <section class="tip-result">
        <i class="result-ico icon-tipico-ok"></i>
        <p class="result-hd">已提交</p>
      </section>
    </x-dialog>
    <section class="btn-bottom addfile-btn-bottom" v-if="this.id">
      <div class="btn-fix addfile-btn"
           v-if="(authId === clue.assignee_id && followPersonClueAuth) || followAllClueAuth">
        <a v-if="clue.status==1 || clue.status==2 || clue.status==3 || clue.status==4" class="btn"
           href="javascript:void(0);" @click.stop="changeArchives()">确认提交</a>
        <a v-if="clue.status==1 || clue.status==2 || clue.status==3 || clue.status==4" class="btn"
           href="javascript:void(0);" @click.stop="changeArchives(1)">添加跟进记录</a>
        <a v-if="clue.status==1" class="btn" href="javascript:void(0);" @click.stop="confirmContacted()">确定联系</a>
        <a v-if="clue.status===3" class="btn" href="javascript:void(0);" @click.stop="cancelAppointed()">取消预约</a>
        <a v-else-if="clue.status===1|| clue.status===2" class="btn" href="javascript:void(0);"
           @click.stop="confirmAppointed">确认预约</a>
      </div>
    </section>

    <section class="btn-bottom" v-else>
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="createNewClue">确认提交</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  XDialog,
  XAddress,
  Selector,
  XInput,
  Datetime,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'
import util from '../../../common/util'
import authApi from '../../../common/auth'

export default {
  components: {
    XDialog,
    XAddress,
    Datetime,
    Selector,
    XInput,
    Cell,
    Group
  },
  data () {
    return {
      // 访问页面
      pageAuth: [authApi.saleManage.sale_clue_view_self, authApi.saleManage.sale_clue_view_all],
      // 跟进个人权限
      followPersonClueAuth: false,
      // 跟进全部线索权限
      followAllClueAuth: false,
      authId: '',
      id: '',
      originUrl: 'originUrl',
      localArchivesDataKey: 'clueArchivesLocalData',
      start_date: null,
      end_date: null,
      clue: {
        address: '',
        intention_cars: [],
        contrast_cars: [],
        notes: [],
        priority: 0,
        user_type: 0,
        from_type: '3'
      },
      fromType: [],
      car_color: [],
      isShow: false,
      addressList: [],
      addressObj: {
        province_code: '',
        city_code: '',
        district_code: '',
        province: '',
        city: '',
        district: ''
      },
      channelData: [],
      chanelList: []
    }
  },
  created () {
    this.start_date = this.futureTime(1)
    this.end_date = this.futureTime(180)
    this.$store.state.promiseAuth.then(auth => {
      this.authId = auth.id
      let permission = authApi.haveSomeAuth(this.pageAuth, auth.authList)
      this.followPersonClueAuth = auth.authList.includes(authApi.saleManage.sale_clue_follow_self)
      this.followAllClueAuth = auth.authList.includes(authApi.saleManage.sale_clue_follow_all)
      if (permission) {
        this.$rest.saleManage.getEnums().then((res) => {
          if (res.code === 0) {
            this.fromType = res.data.from_type
            this.car_color = res.data.car_color
            this.channelTypeArr = res.data.channel_type
            this.subChannelTypeArr = res.data.sub_channel_type
            this.channelData = this.getChanelType(this.channelTypeArr, this.subChannelTypeArr)
            // this.chanelList = [this.channelData[0].value, this.channelData[this.channelTypeArr.length].value]
            let query = this.$route.query
            this.id = query.id
            let modelId = query.modelId
            // 是否缓存数据.
            let localData = cache.getSessionData(this.localArchivesDataKey)
            if (localData) {
              if (localData.addressList.length > 2) {
                this.addressList = localData.addressList
              }
              if (localData.chanelList.length > 0) {
                this.chanelList = localData.chanelList
              }
              this.clue = localData.clue
            } else if (this.id) {
              this.getArchivesDetail()
            }
            if (!this.clue.creator) {
              this.clue.creator = auth.userName
            }
            if (modelId) {
              this.$rest.saleManage.getAppointedCarInfo(null, modelId).then((res) => {
                if (res.code === 0) {
                  let outer = query.outer
                  let inner = query.inner
                  // 意向车型
                  if (outer && inner) {
                    let obj = {
                      car_model_id: parseInt(modelId),
                      outer_color: parseInt(outer),
                      inner_color: parseInt(inner),
                      car_model_name: res.data.model_name
                    }
                    let innerColorCh = this.car_color.find(t => {
                      return inner === t.key
                    })
                    if (innerColorCh) {
                      obj.inner_color_ch = innerColorCh.value
                    }
                    let outerColorCh = this.car_color.find(t => {
                      return outer === t.key
                    })
                    if (outerColorCh) {
                      obj.outer_color_ch = innerColorCh.value
                    }
                    // 更改/替换
                    if (localData.chooseItem) {
                      let index = localData.chooseItem.index
                      Object.assign(this.clue.intention_cars[index], obj)
                    } else {
                      // 添加
                      let intentionCarsEX = this.clue.intention_cars.findIndex(x => {
                        return x.car_model_id === parseInt(modelId)
                      })
                      if (intentionCarsEX === -1) {
                        this.clue.intention_cars.push(obj)
                      }
                    }
                  } else {
                    let obj = {
                      model_id: parseInt(modelId),
                      model_name: res.data.model_name
                    }
                    if (localData.chooseItem) {
                      let index = localData.chooseItem.index
                      Object.assign(this.clue.contrast_cars[index], obj)
                    } else {
                      let contrastCarsEX = this.clue.contrast_cars.findIndex(x => {
                        return x.model_id === parseInt(modelId)
                      })
                      if (contrastCarsEX === -1) {
                        this.clue.contrast_cars.push(obj)
                      }
                    }
                  }
                }
              })
            }
          }
        })
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    getValues (type) {
      if (!type) return ''
      let item = this.fromType.find(v => {
        return v.key === type.toString()
      })
      if (item) {
        return item.value
      }
    },
    getArchivesDetail () {
      this.$rest.saleManage.clueArchivesDetail(null, this.id).then(res => {
        if (res.code === 0) {
          this.clue = res.data
          this.clue.from_type = res.data.from_type + ''
          if (this.clue.province_code && this.clue.city_code && this.clue.district_code) {
            this.addressList = [this.clue.province_code, this.clue.city_code, this.clue.district_code]
          }
          this.clue.channel_type = res.data.channel_type + ''
          if (res.data.channel_type > 0) {
            let subChannelT = res.data.sub_channel_type + ''
            let channelT = res.data.channel_type + ''
            if (channelT === '1') {
              subChannelT = `100${subChannelT}`
            } else {
              subChannelT = `${channelT}${channelT}`
            }
            this.chanelList = [channelT, subChannelT]
          } else {
            this.chanelList = []
          }
          this.clue.intention_cars = this.clue.intention_cars.map(v => {
            let innerColorCh = this.car_color.find(t => {
              return v.inner_color === parseInt(t.key)
            })
            if (innerColorCh) {
              v.inner_color_ch = innerColorCh.value
            }
            let outerColorCh = this.car_color.find(t => {
              return v.outer_color === parseInt(t.key)
            })
            if (outerColorCh) {
              v.outer_color_ch = outerColorCh.value
            }
            return v
          })
          this.clue.next_arrive_at = this.clue.next_arrive_at || ''
          this.clue.next_contact_at = this.clue.next_contact_at || ''
        }
      })
    },
    selModels (flag, index, editId) {
      let path = '/salemanage/staff/cluearchives'
      if (this.id) {
        path = path + '?id=' + this.id
      }
      cache.setSessionData(this.originUrl, {
        from: 'cluearchives',
        includeColor: flag,
        path: path
      })
      // 当前页面数据
      let chooseItem = null
      if (typeof index !== 'undefined' && typeof editId !== 'undefined') {
        chooseItem = { index: index, editId: editId }
      }
      cache.setSessionData(this.localArchivesDataKey, {
        clue: this.clue,
        chooseItem: chooseItem,
        addressList: this.addressList,
        chanelList: this.chanelList
      })
      if (flag) {
        this.$router.push('/salemanage/car/intendbrands')
      } else {
        this.$router.push('/salemanage/car/brands')
      }
    },
    basicTransportData (clue) { },
    createNewClue () {
      let mobile = this.clue.mobile
      if (!mobile) {
        this.showToast('请输入联系电话')
        return false
      } else if (!util.regexpMap.regexp_mobile.test(mobile)) {
        this.showToast('请输入正确的手机号')
        return false
      }
      let clue = this.clue
      let transport = {
        address: clue.address,
        customer_name: clue.customer_name,
        mobile: clue.mobile,
        intention_cars: clue.intention_cars,
        priority: clue.priority,
        user_type: clue.user_type,
        from_type: parseInt(clue.from_type),
        contrast_car_ids: clue.contrast_cars.map(v => {
          return parseInt(v.model_id)
        })
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = clue.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      this.$rest.saleManage.createClue(transport).then(res => {
        if (res.code === 0) {
          this.isShow = true
        } else {
          this.showToast(res.message)
        }
      })
    },
    changeArchives (to) {
      let clue = this.clue
      let transport = {
        address: clue.address,
        customer_name: clue.customer_name,
        intention_cars: clue.intention_cars,
        priority: clue.priority,
        user_type: clue.user_type,
        from_type: parseInt(clue.from_type),
        channel_type: parseInt(clue.channel_type),
        next_arrive_at: clue.next_arrive_at ? clue.next_arrive_at + ':00' : null,
        next_contact_at: clue.next_contact_at || null,
        contrast_car_ids: clue.contrast_cars.map(v => {
          return parseInt(v.model_id)
        })
      }
      if (clue.next_arrive_at === '' || clue.next_arrive_at === null) {
        transport.next_arrive_at = null
      } else if (clue.next_arrive_at) {
        let date = new Date(clue.next_arrive_at)
        if (date.getSeconds() > 0 || clue.next_arrive_at.endsWith('00')) {
          transport.next_arrive_at = clue.next_arrive_at
        } else {
          transport.next_arrive_at = clue.next_arrive_at + ':00'
        }
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = clue.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      transport.id = parseInt(this.id)
      this.$rest.saleManage.updateClue(transport).then(res => {
        if (res.code === 0) {
          if (to) {
            this.$router.push('/salemanage/staff/addcluerecord/' + this.id)
          } else {
            this.showToast('操作成功')
          }
        } else {
          this.showToast(res.message)
        }
      })
    },
    getChanelType (list, subList) {
      let listArr = []
      list.forEach(v => {
        listArr.push({
          name: v.value,
          value: v.key
        })
      })
      list.forEach(v => {
        if (v.value === '网络渠道') {
          subList.forEach(j => {
            listArr.push({
              name: j.value,
              value: `${v.key}00${j.key}`,
              parent: v.key
            })
          })
          listArr.push({
            name: '--',
            value: `${v.key}000`,
            parent: v.key
          })
        } else {
          listArr.push({
            name: '--',
            value: v.key + v.key,
            parent: v.key
          })
        }
      })
      return listArr
    },
    confirmContacted () {
      if (!this.clue.next_contact_at) {
        this.showToast('请先设置下次致电日期')
        return false
      }
      let clue = this.clue
      let transport = {
        address: clue.address,
        customer_name: clue.customer_name,
        intention_cars: clue.intention_cars,
        from_type: parseInt(clue.from_type),
        channel_type: parseInt(clue.channel_type),
        next_arrive_at: clue.next_arrive_at ? clue.next_arrive_at + ':00' : null,
        next_contact_at: clue.next_contact_at || null,
        contrast_car_ids: clue.contrast_cars.map(v => {
          return parseInt(v.model_id)
        })
      }
      if (clue.next_arrive_at === '' || clue.next_arrive_at === null) {
        transport.next_arrive_at = null
      } else if (clue.next_arrive_at) {
        let date = new Date(clue.next_arrive_at)
        if (date.getSeconds() > 0 || clue.next_arrive_at.endsWith('00')) {
          transport.next_arrive_at = clue.next_arrive_at
        } else {
          transport.next_arrive_at = clue.next_arrive_at + ':00'
        }
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = clue.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      transport.id = parseInt(this.id)
      this.$rest.saleManage.clueConfirmContacted(transport).then(res => {
        if (res.code === 0) {
          this.showToast('操作成功')
          this.clue.status = res.data.status
          this.clue.next_arrive_at = res.data.next_arrive_at === null ? '' : res.data.next_arrive_at
        } else {
          this.showToast(res.message)
        }
      })
    },
    cancelAppointed () {
      let clue = this.clue
      let transport = {
        address: clue.address,
        customer_name: clue.customer_name,
        intention_cars: clue.intention_cars,
        channel_type: parseInt(clue.channel_type),
        from_type: parseInt(clue.from_type),
        next_contact_at: clue.next_contact_at || null,
        id: parseInt(this.id),
        contrast_car_ids: clue.contrast_cars.map(v => {
          return parseInt(v.model_id)
        })
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = clue.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      this.$rest.saleManage.cancelBookClue(transport).then(res => {
        if (res.code === 0) {
          this.showToast('操作成功')
          this.clue.status = res.data.status
          this.clue.next_arrive_at = res.data.next_arrive_at === null ? '' : res.data.next_arrive_at
        } else {
          this.showToast(res.message)
        }
      })
    },
    confirmAppointed () {
      if (!this.clue.next_arrive_at) {
        this.showToast('请先设置预约到店时间')
        return false
      }
      let clue = this.clue
      let transport = {
        address: clue.address,
        customer_name: clue.customer_name,
        intention_cars: clue.intention_cars,
        from_type: parseInt(clue.from_type),
        channel_type: parseInt(clue.channel_type),
        next_arrive_at: clue.next_arrive_at ? clue.next_arrive_at + ':00' : null,
        next_contact_at: clue.next_contact_at || null,
        contrast_car_ids: clue.contrast_cars.map(v => {
          return parseInt(v.model_id)
        })
      }
      if (clue.next_arrive_at === '' || clue.next_arrive_at === null) {
        transport.next_arrive_at = null
      } else if (clue.next_arrive_at) {
        let date = new Date(clue.next_arrive_at)
        if (date.getSeconds() > 0 || clue.next_arrive_at.endsWith('00')) {
          transport.next_arrive_at = clue.next_arrive_at
        } else {
          transport.next_arrive_at = clue.next_arrive_at + ':00'
        }
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = clue.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      transport.id = parseInt(this.id)
      this.$rest.saleManage.clueConfirmAppointed(transport).then(res => {
        if (res.code === 0) {
          this.showToast('操作成功')
          this.clue.status = res.data.status
          this.clue.next_arrive_at = res.data.next_arrive_at === null ? '' : res.data.next_arrive_at
        } else {
          this.showToast(res.message)
        }
      })
    },
    futureTime (days) {
      let millSeconds = Math.abs(new Date().getTime() + (days * 24 * 60 * 60 * 1000))
      let future = new Date(millSeconds)
      let year = future.getFullYear()
      let month = future.getMonth() + 1
      if (month < 10) month = '0' + month
      let date = future.getDate()
      if (date < 10) date = '0' + date
      return (year + '-' + month + '-' + date)
    },
    /**
       * @description 处理地区来源的值
       * @param addressData { Object }
       */
    handleAddress(addressData) {
      this.addressObj = {
        province_code: addressData.provinceCode,
        city_code: addressData.cityCode,
        district_code: addressData.districtCode,
        province: addressData.province,
        city: addressData.city,
        district: addressData.district
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
